export default __webpack_public_path__ + "static/media/GearTrainsImg.3daafa4f.jpg";